import React from "react";
import {ValueValidator} from "../Validator";
import {OnValidChangeHandler, ValidationComponent, ValidationFieldName} from "./ValidationComponent";
import {RootState} from "../../../../app/store";
import {CustomColorField} from "../../customColorField/CustomColorField";

interface Props<OBJECT> {
    validator: ValueValidator<string>
    selector: (state: RootState) => string | undefined
    fieldName: ValidationFieldName<OBJECT>
    onChange: (value: string) => any
    updateValidationStatus: OnValidChangeHandler<OBJECT>
    label: string
    disabled?: boolean
    required?: boolean
    getMessage: (f: string) => string
}

export const ValidatedColorField = <OBJECT,>({
                                                 validator,
                                                 selector,
                                                 fieldName,
                                                 onChange,
                                                 updateValidationStatus,
                                                 label,
                                                 disabled,
                                                 getMessage,
                                                 required = true
                                             }: Props<OBJECT>) => {
    return <ValidationComponent<string, OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        disabled={disabled}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <CustomColorField
                isRequired={required}
                title={label}
                value={value}
                disabled={disabled}
                setValue={onChange}
                errorMessage={getMessage(fieldName as string)}
            />
        }
    />
};
